import Bowser from "bowser";

export default function mobileDetector() {
  const { os: { name }, platform: { type } } = Bowser.getParser(window.navigator.userAgent).parsedResult;
  if (name === "iOS" || name === "Android" || type === "tablet" || type === "mobile") {
    return true;
  }
}